import * as common_pb from 'respona_api/generated/common_pb';
import { AppTypes } from '@ts/common.types';
import { RealmType } from 'respona_api/generated/common_pb';
import { INTEGRATION_MODES } from '@constants/app-modes';

declare const REALM: string;

export const getRealm = (): common_pb.RealmTypeMap[keyof common_pb.RealmTypeMap] => {
  switch (REALM) {
    case AppTypes.concierge:
      return RealmType.RESPONA_CONCIERGE;
    case AppTypes.app:
    case 'semrush':
      return RealmType.RESPONA_APP;
    case AppTypes.publisher:
      return RealmType.RESPONA_PUBLISHER;
    default:
      throw new Error(`Unrecognized App type: ${REALM}`);
  }
};

export const getRealmTitle = (): string => {
  switch (REALM) {
    case AppTypes.concierge:
      return 'DFY: Client';
    case AppTypes.app:
    case 'semrush':
      return 'DIY: App';
    case AppTypes.publisher:
      return 'DFY: Publisher';
    default:
      throw new Error(`Unrecognized App type: ${REALM}`);
  }
};

export const isPublisherRealm = (): boolean => REALM === AppTypes.publisher;
export const isConciergeRealm = (): boolean => REALM === AppTypes.concierge;
export const isAppRealm = (): boolean => REALM === AppTypes.app || REALM === 'semrush';
